import styled from "styled-components";

export const HistoryCardsStyled = styled.div`
    gap: 8px
`